import script from "./TabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TabBar.vue?vue&type=script&setup=true&lang=js"

import "./TabBar.vue?vue&type=style&index=0&id=6644f140&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6644f140"]])

export default __exports__